var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582_19708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5V7.375V7.45703V7.8125V12.543V13.0625V13.5V15.1926V16.0949V17.2188V17.6562C10.5 18.3809 11.6758 18.9688 13.125 18.9688C14.5742 18.9688 15.75 18.3809 15.75 17.6562C15.75 16.9316 14.5742 16.3438 13.125 16.3438C12.4523 16.3438 11.8398 16.4695 11.375 16.6773V15.9062C12.168 15.7668 13.0566 15.6875 14 15.6875C15.8484 15.6875 17.4809 15.9938 18.6211 16.4559C19.1926 16.6883 19.5945 16.9426 19.8434 17.1805C20.0895 17.4156 20.125 17.577 20.125 17.6562C20.125 17.7355 20.0895 17.8969 19.8434 18.132C19.5973 18.3699 19.1926 18.6242 18.6211 18.8566C17.4809 19.3187 15.8484 19.625 14 19.625C12.1516 19.625 10.5191 19.3187 9.37891 18.8566C8.80742 18.6242 8.40547 18.3699 8.15664 18.132C7.91055 17.8969 7.875 17.7355 7.875 17.6562C7.875 17.577 7.91055 17.4156 8.15664 17.1805C8.40273 16.9426 8.80742 16.6883 9.37891 16.4559C9.4582 16.423 9.54023 16.3902 9.625 16.3602V15.4359C8.02539 15.9582 7 16.7594 7 17.6562C7 19.2258 10.1336 20.5 14 20.5C17.8664 20.5 21 19.2258 21 17.6562C21 16.0867 17.8664 14.8125 14 14.8125C13.073 14.8125 12.1844 14.8863 11.375 15.0203V13.1117L17.2977 10.4785L18.375 10L17.2977 9.52148L11.375 6.88828L10.5 6.5Z",
    fill: "#5F6F7C"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.5,
    stroke: "#5F6F7C",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_19708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/Events.225761705fa990b91e260f1dbaf8f72f.svg";
export { ForwardRef as ReactComponent };